import tw from "twin.macro"
import Loading from "./Loading"

export default function PageBase({ title, type = "text", openAI, children }) {
  const { response, loading, error, resetMemory } = openAI

  return (
    <Wrapper>
      <Title>{title}</Title>
      <PromptWrapper>
        <button onClick={resetMemory}>Reset Memory</button>
        {children}
      </PromptWrapper>
      {type === "text" && !error && (
        <div className="flex flex-col gap-5">
          {response.map(res => (
            <ResponseText>{res}</ResponseText>
          ))}
        </div>
      )}
      {type === "image" && !error && !loading && (
        <Image src={response} aly="AI generated image" />
      )}
      {loading && <Loading />}
      {error && !loading && <Error>Something went wrong</Error>}
    </Wrapper>
  )
}

const Wrapper = tw.div`mt-8 flex flex-col items-center gap-4`
const Title = tw.h1`text-3xl font-bold`

const PromptWrapper = tw.div`flex flex-col gap-4 w-full px-8`
const PromptText = tw.p`max-w-[32rem] mx-auto px-2`
const ResponseText = tw.p`max-w-[32rem] text-xl text-center px-2`
const Image = tw.img`max-w-[32rem] mx-auto`
const Error = tw.p`text-xl text-red-500`
